import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100vw", height: "100vh",
        display: "flex", alignItems: "center", justifyContent: "center",
        backgroundColor: theme.palette.background ? theme.palette.background.default : "#f5f5f5",
    },
    paper: {
        display: "flex", flexDirection: "column", alignItems: "center",
        padding: "40px 32px", borderRadius: 12,
        backgroundColor: "#fff",
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
        width: "100%", maxWidth: 400,
    },
    title: { marginBottom: 24, fontWeight: 700 },
    form: { width: "100%", marginTop: 8 },
    submit: { margin: theme.spacing(3, 0, 2) },
    link: { marginTop: 8, display: "block", textAlign: "center" }
}));

const ForgetPassword = () => {
    const classes = useStyles();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await openApi.post("/auth/forgot-password", { email });
            toast.success("E-mail de recuperação enviado! Verifique sua caixa de entrada.");
        } catch (err) {
            toastError(err);
        }
        setLoading(false);
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5" className={classes.title}>
                    Recuperar senha
                </Typography>
                <Typography variant="body2" color="textSecondary" align="center" style={{marginBottom: 24}}>
                    Digite seu e-mail e enviaremos um link para redefinir sua senha.
                </Typography>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <TextField
                        variant="outlined" margin="normal" required fullWidth
                        label="E-mail" type="email" autoFocus
                        value={email} onChange={(e) => setEmail(e.target.value)}
                    />
                    <Button
                        type="submit" fullWidth variant="contained" color="primary"
                        className={classes.submit} disabled={loading}
                    >
                        {loading ? "Enviando..." : "Enviar link de recuperação"}
                    </Button>
                    <Grid container justifyContent="center">
                        <Grid item>
                            <Link component={RouterLink} to="/login" variant="body2">
                                Voltar para o login
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </div>
    );
};

export default ForgetPassword;
